import { render, staticRenderFns } from "./WorkBookAddFranchise.vue?vue&type=template&id=04c43cc0&scoped=true&"
import script from "./WorkBookAddFranchise.vue?vue&type=script&lang=js&"
export * from "./WorkBookAddFranchise.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookAddFranchise.vue?vue&type=style&index=0&id=04c43cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c43cc0",
  null
  
)

export default component.exports